import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "mb-3" }
const _hoisted_2 = ["for"]
const _hoisted_3 = ["id"]
const _hoisted_4 = { class: "mb-3" }
const _hoisted_5 = ["for"]
const _hoisted_6 = ["id"]
const _hoisted_7 = {
  key: 0,
  class: "mb-3"
}
const _hoisted_8 = {
  key: 0,
  class: "mt-2"
}
const _hoisted_9 = { class: "text-success" }

import { computed, inject } from 'vue';
    import type { AuthState, AuthMethods } from '../composables/useAuth';
    import { AUTH_STATE_KEY, AUTH_METHODS_KEY } from '../composables/authKeys';

    interface Props {
        direction: 'Source' | 'Destination';
        serverType: string;
        migrationType: 'Mail' | 'Contacts';
        onAuthError: (title: string, message: string) => void;
    }

    
export default /*@__PURE__*/_defineComponent({
  __name: 'OAuthAuthSection',
  props: {
    direction: {},
    serverType: {},
    migrationType: {},
    onAuthError: { type: Function }
  },
  setup(__props: any) {

    const props = __props;

    const authState = inject(AUTH_STATE_KEY) as AuthState;
    const authMethods = inject(AUTH_METHODS_KEY) as AuthMethods;

    const serverRef = computed(() => 
        props.direction === 'Source' ? authState.sourceServer : authState.destServer
    );

    const userRef = computed(() => 
        props.direction === 'Source' ? authState.sourceUser : authState.destUser
    );

    const oauthStatusRef = computed(() => 
        props.direction === 'Source' ? authState.sourceOAuthStatus : authState.destOAuthStatus
    );

    function handleOAuth() {
        authMethods.invokeOAuth(props.direction, props.migrationType, props.onAuthError);
    }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("label", {
        for: `${__props.direction}Server`,
        class: "form-label"
      }, "Server", 8 /* PROPS */, _hoisted_2),
      _withDirectives(_createElementVNode("input", {
        type: "text",
        class: "form-control bg-secondary bg-opacity-25",
        id: `${__props.direction}Server`,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((serverRef.value.value) = $event)),
        readonly: "",
        required: ""
      }, null, 8 /* PROPS */, _hoisted_3), [
        [_vModelText, serverRef.value.value]
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("label", {
        for: `${__props.direction}User`,
        class: "form-label"
      }, "Username", 8 /* PROPS */, _hoisted_5),
      _withDirectives(_createElementVNode("input", {
        type: "text",
        class: "form-control bg-secondary bg-opacity-25",
        id: `${__props.direction}User`,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((userRef.value.value) = $event)),
        readonly: "",
        required: ""
      }, null, 8 /* PROPS */, _hoisted_6), [
        [_vModelText, userRef.value.value]
      ])
    ]),
    (__props.serverType)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-outline-primary",
            onClick: handleOAuth
          }, [
            _cache[2] || (_cache[2] = _createElementVNode("i", { class: "bi bi-google" }, null, -1 /* CACHED */)),
            _createTextVNode(" Authenticate with " + _toDisplayString(__props.serverType), 1 /* TEXT */)
          ]),
          (oauthStatusRef.value.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createElementVNode("span", _hoisted_9, [
                  _cache[3] || (_cache[3] = _createElementVNode("i", { class: "bi bi-check-circle" }, null, -1 /* CACHED */)),
                  _createTextVNode(" " + _toDisplayString(oauthStatusRef.value.value), 1 /* TEXT */)
                ])
              ]))
            : _createCommentVNode("v-if", true)
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}
}

})